import { ActionCreator } from "redux";

import {
	ActionType,
	SettingsSignatureAddedAction,
	SettingsSignaturesUpdatedAction,
	SettingsSignatureRemovedAction,
	SettingsSingleSignatureUpdatedAction,
	SettingsMealAddedAction,
	SettingsMealRemovedAction,
	SettingsSingleMealUpdatedAction,
	SettingsMealsUpdatedAction
} from "./type";
import { MessageSignature } from "../../api/settings";
import { Meal } from '../../api/meals';

export const addSignature: ActionCreator<SettingsSignatureAddedAction> = (
	signature: MessageSignature
) => ({
	type: ActionType.SettingsSignatureAdded,
	payload: {
		signature
	}
});

export const updateSignatures: ActionCreator<
	SettingsSignaturesUpdatedAction
> = (signatures: MessageSignature[]) => ({
	type: ActionType.SettingsSignaturesUpdated,
	payload: {
		signatures
	}
});

export const updateSingleSignature: ActionCreator<
	SettingsSingleSignatureUpdatedAction
> = (id: string, signature: MessageSignature) => ({
	type: ActionType.SettingsSingleSignatureUpdated,
	payload: {
		id,
		signature
	}
});

export const removeSignature: ActionCreator<SettingsSignatureRemovedAction> = (
	id: string
) => ({
	type: ActionType.SettingsSignatureRemoved,
	payload: {
		id
	}
});


export const addMeal: ActionCreator<SettingsMealAddedAction> = (
	meal: Meal
) => ({
	type: ActionType.SettingsMealAdded,
	payload: {
		meal
	}
});

export const updateMeals: ActionCreator<
	SettingsMealsUpdatedAction
> = (meals: Meal[]) => ({
	type: ActionType.SettingsMealsUpdated,
	payload: {
		meals
	}
});

export const updateSingleMeal: ActionCreator<
	SettingsSingleMealUpdatedAction
> = (id: string, meal: Meal) => ({
	type: ActionType.SettingsSingleMealUpdated,
	payload: {
		id,
		meal
	}
});

export const removeMeal: ActionCreator<SettingsMealRemovedAction> = (
	id: string
) => ({
	type: ActionType.SettingsMealRemoved,
	payload: {
		id
	}
});
